var _defs, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvalancheChain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 693.26 257.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e84142;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M387.83,532.37c-6.74-11.84-17.84-11.87-24.65-.08L320,607.08c-6.81,11.8-1.24,21.46,12.39,21.46h85.47c13.62,0,19.25-9.69,12.5-21.53Z",
    transform: "translate(-153.4 -370.75)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M337.75,444.45l-22.52-39.53h0L305.57,388c-6.74-11.84-17.78-11.84-24.52,0L156.26,607c-6.75,11.84-1.12,21.53,12.51,21.53H231.4c11.35,0,25.29-8,31-17.88l75.28-130.39C343.32,470.44,343.37,454.32,337.75,444.45Z",
    transform: "translate(-153.4 -370.75)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M801.27,532.37c-6.74-11.84-17.83-11.87-24.65-.08l-43.18,74.79c-6.81,11.8-1.24,21.46,12.39,21.46H831.3c13.62,0,19.25-9.69,12.51-21.53Z",
    transform: "translate(-153.4 -370.75)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M751.19,444.45l-22.52-39.53h0L719,388c-6.74-11.84-17.78-11.84-24.52,0L569.7,607c-6.75,11.84-1.12,21.53,12.51,21.53h62.63c11.36,0,25.29-8,31-17.88l75.28-130.39C756.76,470.44,756.81,454.32,751.19,444.45Z",
    transform: "translate(-153.4 -370.75)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M637.1,392.27c6.75-11.84,1.12-21.52-12.5-21.52H539.13c-13.63,0-19.2,9.65-12.39,21.45L569.92,467c6.82,11.8,17.91,11.77,24.65-.07Z",
    transform: "translate(-153.4 -370.75)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M544.49,554.83,522,594.36h0l-9.65,16.93c-6.74,11.84-17.78,11.84-24.52,0L363,392.27c-6.75-11.84-1.12-21.52,12.51-21.52h62.63c11.35,0,25.29,8,31,17.87L544.39,519C550.06,528.85,550.11,545,544.49,554.83Z",
    transform: "translate(-153.4 -370.75)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvalancheChain);
export default __webpack_public_path__ + "static/media/avalanche-chain.0643a99a.svg";
export { ForwardRef as ReactComponent };